module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingForsaljning.bae0d63e.png";